module.exports = __webpack_public_path__ + "img/midBanner01.1da2f18d.jpg";